import { api } from "../api";

/**
 * logFindAllListResponse - Function that finds on database all logs by user, customer and action    
 * /log/list    
 * method GET 
 * @async-function
 */
const logFindAllListResponse = async (
    token: string,
    userId?: number | null,
    customerId?: number | null,
    action?: string | null,
    entityName?: string | null,
    page: number = 0,
    size: number = 100
) => {

    const params = {
        ...(userId && userId > 0 && { userId }),
        ...(customerId && customerId > 0 && { customerId }),
        ...(action?.trim() && { action: action.trim() }),
        ...(entityName?.trim() && { entityName: entityName.trim() }),
        page,
        size
    };

    const response = await api.get("/logs/list", {
        params,
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return response;
};

export default logFindAllListResponse;
